import { inject, observer } from "mobx-react";
import { Component } from "react";
import { Translation } from "react-i18next";
import type { Store } from "../../../client/stores";
import { ClickSection } from "../lib/clickSection";
import "./Header.style.scss";
import { HeaderSearch } from "./HeaderSearch.component";
import { HeaderUser } from "./HeaderUser.component";
import { Navigation } from "./Navigation.component";
import { StationLogo } from "./StationLogo.component";

export interface HeaderProps {
    /**
     * SiteConfig Object, see type SiteBrand
     *
     * @default SiteBrand Object, not null
     */
    open?: boolean;
    store?: Store;
}

@inject("store")
@observer
export class Header extends Component<HeaderProps> {
    public render() {
        const { store } = this.props;
        if (!store) {
            return null;
        }
        const { site } = store;
        const { sections } = site;

        return (
            <header className="component-site-header">
                <section className="main-header-items">
                    <ClickSection.Provider value="nav">
                        <Translation>
                            {t => (
                                <Navigation
                                    menus={sections.navigation?.menu}
                                    open={this.props.open}
                                    sections={sections}
                                    t={t}
                                />
                            )}
                        </Translation>
                    </ClickSection.Provider>
                    <ClickSection.Provider value="header">
                        <StationLogo />
                        <section className="search-user-container">
                            {sections.navigation?.search_switch ? <HeaderSearch location="header" /> : null}
                            <HeaderUser location="header" showMenu={false} />
                        </section>
                    </ClickSection.Provider>
                </section>
            </header>
        );
    }
}
